import moment from 'moment';
import React, { Component } from 'react';
import { getLoggedInUser } from '../../helpers/authUtils';
import ContAnexo from '../Paciente/ContAnexo';
import ImageView from '../../gb-components/ImageView';

export default class DadosFila extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // ou está logado como paciente ou está logado como secretario vendo os dados do paciente
            nomePaciente: this.props.item.paciente && this.props.item.paciente.paciente ? this.props.item.paciente.paciente.nome : getLoggedInUser().username,
            dataAgendamento: null,
            horaAgendamento: null
        }
    }
    componentDidMount() {
        console.log(this.props.item)
        console.log(this.props.item.arquivo)
        if (this.props.item.dataAgendamento) {
            this.setState({
                dataAgendamento: this.props.item.dataAgendamento,
                horaAgendamento: this.props.item.horaAgendamento,
            })
        } else {
            this.setState({
                dataAgendamento: this.props.item.data_agendamento,
                horaAgendamento: this.props.item.hora_agendamento,

            })
        }
    }

    render() {
        return (
            <div className="">
                <h3>Detalhes</h3>
                <hr />
                {this.props.item &&
                    <div className='gb-card'>
                        <div className="gb-card-body">
                            <div className="row">
                                <div className="col-md-6">
                                    <small className='title-fila'>Paciente:</small>
                                    <p className="subtitle">{this.state.nomePaciente}</p>
                                </div>
                                <div className="col-md-6">
                                    <small className='title-fila'>Procedimento</small>
                                    <p>{this.props.item.procedimento.codigo} - {this.props.item.procedimento.descricao}</p>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-3">
                                    <small className='title-fila'>Status</small>
                                    <p>{this.props.item.status}</p>
                                </div>
                                <div className="col-md-3">
                                    <small className='title-fila'>Data Criação</small>
                                    <p>{moment(this.props.item.created_at).format("DD/MM/YYYY")}</p>
                                </div>
                                <div className="col-md-3">
                                    <small className='title-fila'>Data Agendamento</small>
                                    <p>{this.state.dataAgendamento && moment(this.state.dataAgendamento).format("DD/MM/YYYY") + " - " + this.state.horaAgendamento}</p>
                                </div>
                                <div className="col-md-3">
                                    <small className='title-fila'>Confirmação do Paciente</small>
                                    <p>{this.props.item.confirmed == null ? "Pendente" : this.props.item.confirmed == true ? "Confirmado" : "Não Confirmado"}</p>
                                </div>
                            </div>
                            <div className="row">
                                {this.props.item.arquivo ?
                                    <ImageView
                                        midias={[{ src: this.props.item.arquivo }]}
                                        edit={false}
                                    /> : null
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
